import { render, staticRenderFns } from "./uiBlockTitle.vue?vue&type=template&id=0637d3be&scoped=true"
var script = {}
import style0 from "./uiBlockTitle.vue?vue&type=style&index=0&id=0637d3be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0637d3be",
  null
  
)

export default component.exports